import { render, staticRenderFns } from "./Meservation.vue?vue&type=template&id=4285d322&scoped=true"
import script from "./Meservation.vue?vue&type=script&lang=js"
export * from "./Meservation.vue?vue&type=script&lang=js"
import style0 from "./Meservation.vue?vue&type=style&index=0&id=4285d322&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4285d322",
  null
  
)

export default component.exports